module.exports = __webpack_public_path__ + "img/candy-wing2.f0a4dab5.png";